import classNames from 'classnames'
import {
  DetailedHTMLProps,
  FC,
  ForwardedRef,
  forwardRef,
  InputHTMLAttributes,
} from 'react'
import Input from 'shared/components/elements/input'

import BaseLabel, { BaseLabelProps } from '../BaseLabel'
import BaseInputLeadingIcon from './base-input-leading-icon'
import BaseInputTrailingIcon from './base-input-trailing-icon'

export type BaseInputPropType = {
  trailingIcon?: FC
  leadingIcon?: FC
  label?: string
  textClassName?: string
  inputClassName?: string
  labelProps?: BaseLabelProps
} & DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>
const BaseInput = forwardRef(
  (props: BaseInputPropType, ref: ForwardedRef<HTMLInputElement>) => {
    const {
      label,
      className,
      leadingIcon,
      trailingIcon,
      inputClassName,
      labelProps,
      textClassName,
      ...restProps
    } = props

    const getInputXPadding = () => {
      let className = ''
      if (leadingIcon) {
        className += 'pl-6 '
      }
      if (trailingIcon) {
        className += 'pr-6 '
      }
      return className
    }

    return (
      <div className={className || ''}>
        {label && <BaseLabel {...labelProps}>{label}</BaseLabel>}
        <div
          className={classNames(
            'rounded-md px-3 py-2 shadow-sm relative',
            'border border-gray-light hover:border hover:border-gray-medium focus-within:border-gray-medium',
            inputClassName || ''
          )}
        >
          <BaseInputLeadingIcon icon={leadingIcon} />
          <Input
            tabIndex={-1}
            autoComplete="off"
            type="text"
            className={`block w-full border-0 p-0 text-gray-900 placeholder-gray-500 sm:text-sm focus:ring-transparent ${getInputXPadding()} ${textClassName}`}
            {...restProps}
            ref={ref}
          />
          <BaseInputTrailingIcon icon={trailingIcon} />
        </div>
      </div>
    )
  }
)

BaseInput.displayName = 'BaseInput'

export default BaseInput
